import VideoCollection from './VideoCollection';

export default VideoCollection;
